import React from 'react';
import { BrandButton } from './BrandButton';
interface CtaBandProps {
  title?: string;
  body?: string;
  label?: string;
}
export function CtaBand({
  title = 'More appointments. More closings. More money in the team every month.',
  body = 'The leads are already paid for. The only variable left is who answers first. Book the audit and we will show you exactly where your team is losing the race.',
  label = 'Book your free Response Audit'
}: CtaBandProps) {
  return <section aria-labelledby="cta-band-title" className="bg-ink-800" data-id="element-43" data-mp="vgwufdvk2ljf">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-44" data-mp="vf3pq44i6be2">
        <div className="flex flex-col gap-8 rounded-2xl border border-white/10 bg-ink-700 p-8 sm:p-12 lg:flex-row lg:items-center lg:justify-between" data-id="element-45" data-mp="108y4qu95y26t">
          <div className="max-w-2xl" data-id="element-46" data-mp="1a5t39d5fs2l3">
            <h2 id="cta-band-title" className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-47" data-mp="1a6vpv8vq7iv7">
              {title}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-48" data-mp="1z86dl0enk8br">
              {body}
            </p>
          </div>
          <BrandButton label={label} size="lg" withArrow className="flex-none" data-id="element-49" data-mp="1uamw7rmnrffl" />
        </div>
      </div>
    </section>;
}